var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import ThemeContext from '../../context/theme-context';
import { convertToCSSValue, updateStylesheet } from '../../helpers/styles';
import Widget from '../Widget';
var getObjectId = function (object) { return object.id || object.identifier; };
var StyledWindow = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: ", ";\n  box-sizing: ", ";\n  top: ", ";\n  left: ", ";\n  height: ", ";\n  width: ", ";\n  border: ", ";\n  display: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  z-index: ", ";\n  background-color: ", ";\n  ", "\n  div {\n    box-sizing: ", ";\n  }\n"], ["\n  position: ", ";\n  box-sizing: ", ";\n  top: ", ";\n  left: ", ";\n  height: ", ";\n  width: ", ";\n  border: ",
    ";\n  display: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  z-index: ", ";\n  background-color: ", ";\n  ",
    "\n  div {\n    box-sizing: ", ";\n  }\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.position;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.boxSizing;
}, function (_a) {
    var yPosition = _a.yPosition;
    return convertToCSSValue(yPosition);
}, function (_a) {
    var xPosition = _a.xPosition;
    return convertToCSSValue(xPosition);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.width;
}, function (_a) {
    var windowTheme = _a.windowTheme, showBorder = _a.showBorder;
    return showBorder === 'false' ? 'unset' : windowTheme.window.border;
}, function (_a) {
    var visible = _a.visible;
    return (visible ? 'block' : 'block');
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.fontFamily;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.fontSize;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.zIndex;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.background;
}, function (_a) {
    var attributes = _a.attributes, type = _a.type;
    return attributes &&
        attributes.styleSheet &&
        updateStylesheet(attributes.styleSheet._, type);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.boxSizing;
});
var StyledTitle = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: ", ";\n  height: ", ";\n  background: ", ";\n  color: ", ";\n  border: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  border-right-color: ", ";\n  border-bottom-color: ", ";\n  text-align: ", ";\n"], ["\n  position: ", ";\n  height: ", ";\n  background: ", ";\n  color: ", ";\n  border: ", ";\n  border-left-color: ",
    ";\n  border-top-color: ",
    ";\n  border-right-color: ",
    ";\n  border-bottom-color: ",
    ";\n  text-align: ", ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.title.position;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.title.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.title.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.title.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.title.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.title.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.title.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.title.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.title.borderColor.bottom;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.title.textAlign;
});
var StyledContent = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: ", ";\n  background: ", ";\n\n  & > div {\n    position: ", ";\n  }\n"], ["\n  position: ", ";\n  background: ", ";\n\n  & > div {\n    position: ", ";\n  }\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.content.position;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.content.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.content.div.position;
});
var Window = function (props) {
    var _a, _b, _c, _d, _e;
    var getWidget = function (search, searchBy) {
        if (searchBy === void 0) { searchBy = 'id'; }
        var window = props.window;
        var findWidget = function (widget, search, searchBy) {
            if (searchBy === 'id' && getObjectId(widget) === search) {
                return widget;
            }
            else {
                var keys = searchBy.split('.');
                var target = widget;
                for (var i = 0; i < keys.length; i++) {
                    if (!target)
                        break;
                    target = target[keys[i]];
                }
                if (target === search) {
                    return widget;
                }
            }
            var childWidgets = (widget || []).childWidgets;
            for (var i = 0; i < childWidgets.length; i++) {
                var found = findWidget(childWidgets[i], search, searchBy);
                if (found)
                    return found;
            }
        };
        return findWidget(window, search, searchBy);
    };
    var form = props.form, window = props.window, restProps = __rest(props, ["form", "window"]);
    var windowTheme = useContext(ThemeContext);
    if (((_a = window.type) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'panel' ||
        ((_b = window.type) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'qwidget' ||
        ((_c = window.type) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === 'qmainwindow' ||
        ((_d = window.type) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === 'qframe' ||
        ((_e = window.type) === null || _e === void 0 ? void 0 : _e.toLowerCase()) === 'qdialog') {
        var attributes = window.attributes, windowTitle = attributes.windowTitle, showBorder = attributes.showBorder;
        console.log({ showBorder: showBorder });
        return (React.createElement(StyledWindow, __assign({}, window, restProps, { windowTitle: windowTitle, windowTheme: windowTheme, attributes: attributes, className: "window-container", showBorder: showBorder }),
            windowTitle && (React.createElement(StyledTitle, __assign({}, restProps, { windowTheme: windowTheme }),
                React.createElement("span", null, windowTitle))),
            React.createElement(StyledContent, { windowTheme: windowTheme },
                React.createElement(Widget, __assign({}, window, restProps, { form: form, windowId: window.identifier, getWidget: getWidget })))));
    }
    return null;
};
export default Window;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map